import { PropsWithChildren, createContext, useState } from "react";
import { TypeRuang, TypeRuangContext } from "../utils/types";
import axios from "axios";
import { FAILED_DATA } from "../utils/constants.tsx";
import { host } from "./config";

axios.defaults.withCredentials = true;
const initialState: TypeRuangContext = {
  ruangList: [],
  allRuangList: [],
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
  isLoadingGet: false,
};
export const RuangContext = createContext<TypeRuangContext>(initialState);
const RuangState: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, setState] = useState<TypeRuangContext>(initialState);
  const dispatch = (payload: Partial<TypeRuangContext>) => {
    setState((prevState) => ({
      ...prevState,
      ...payload,
    }));
  };

  const getRuang = async (data: {
    page?: number;
    query?: string;
    sort_field?: string;
    is_asc?: boolean;
  }) => {
    dispatch({ isLoadingGet: true });
    try {
      const res = await axios.get(host + "/ruang/get_ruang.php", {
        params: data,
      });
      if (res.data.success) {
        dispatch({
          ruangList: res.data.data || [],
          pagination: res.data.pagination,
        });
      }
      return res.data;
    } catch (err) {
      return FAILED_DATA;
    } finally {
      dispatch({ isLoadingGet: false });
    }
  };

  const getAllRuang = async () => {
    dispatch({ isLoadingGet: true });
    try {
      const res = await axios.get(host + "/ruang/get_all_ruang.php");
      if (res.data.success) {
        dispatch({
          allRuangList: res.data.data || [],
        });
      }
      return res.data;
    } catch (err) {
      return FAILED_DATA;
    } finally {
      dispatch({ isLoadingGet: false });
    }
  };

  const addRuang = async (data: TypeRuang) => {
    try {
      const res = await axios.post(host + "/ruang/add_ruang.php", data);
      return res.data;
    } catch (err) {
      return FAILED_DATA;
    }
  };

  const editRuang = async (data: Partial<TypeRuang>) => {
    try {
      const res = await axios.post(host + "/ruang/edit_ruang.php", data);

      const prevIndex = state.ruangList.findIndex(
        (item) => item.id === data.id
      );
      if (prevIndex !== -1) {
        const newRuangList = [...state.ruangList];
        newRuangList[prevIndex] = {
          ...newRuangList[prevIndex],
          ...data,
        };
        dispatch({ ruangList: newRuangList });
      }

      return res.data;
    } catch (err) {
      return FAILED_DATA;
    }
  };

  const deleteRuang = async (id: number) => {
    try {
      const res = await axios.post(host + "/ruang/delete_ruang.php", { id });

      const prevIndex = state.ruangList.findIndex((item) => item.id === id);
      if (prevIndex !== -1) {
        const newRuangList = [...state.ruangList];
        newRuangList.splice(prevIndex, 1);
        dispatch({ ruangList: newRuangList });
      }

      return res.data;
    } catch (err) {
      return FAILED_DATA;
    }
  };

  return (
    <RuangContext.Provider
      value={{
        ...state,
        getRuang,
        getAllRuang,
        addRuang,
        editRuang,
        deleteRuang,
      }}
    >
      {children}
    </RuangContext.Provider>
  );
};

export default RuangState;
